"use client"
import styled from "@emotion/styled"
import { GetPageByRouteQuery } from "apollo"
import { useInView } from "react-intersection-observer"
import {
  AnimatedTypography,
  transitionDelayTime,
  TransitionUp,
  useInViewConfig,
} from "ui"
import Container from "ui/Container"
import { sharedColors } from "ui/theme/colors"
import {
  extractProperty,
  getNonUmbracoUrl,
  Link,
  ravKavLocateStations,
  replaceRichTextLinks,
  transformProperties,
} from "utils"

const OuterContainer = styled.div<{ $isGray?: boolean }>`
  width: 100%;
  background-color: ${({ $isGray }) =>
    $isGray ? sharedColors.mediumGrayLight : "transparent"};
`

type Props = {
  data: any
  stationsData: GetPageByRouteQuery
  blockIndex?: number
  isHomepage?: boolean
}

const StyledDiv = styled.div`
  width: 100%;
  padding-top: 32px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 48px;
  }
`

const StyledItemListWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  ${({ theme }) => theme.breakpoints.up("md")} {
    display: flex;
    flex-direction: row;
  }

  /* flex-wrap: wrap; */
  gap: 24px;
  padding-top: 24px;
`

const StyledLinkDiv = styled(Link)`
  text-decoration: none;
  color: #008761;
  font-size: 20px;
  height: 48px;
  padding: 16px;
  border: 1px solid #008761;
  border-radius: 12px;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
`

const StyledTextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`
const MultyURLS = ({ data, stationsData, blockIndex, isHomepage }: Props) => {
  const title = extractProperty(data, "title")
  const text = extractProperty(data, "text")
  const itemsList = extractProperty(data, "itemsList")
  const parsedData = stationsData?.page?.properties || []
  const { blocks } = transformProperties(parsedData)
  const ravKavStation = blocks.blocks.find(
    (b: any) => b.blockType === "ravKavServiceStation",
  )
  const stationsList = extractProperty(ravKavStation, "itemsList")
  const { ref, inView } = useInView(useInViewConfig)
  const isGray = isHomepage && typeof blockIndex === "number" && blockIndex % 2 === 1
  return (
    <OuterContainer $isGray={isGray}>
      <StyledDiv ref={ref}>
        <Container paddingMobile>
        <StyledTextBox>
          <AnimatedTypography variant="h3" $inview={inView}>
            {title}
          </AnimatedTypography>
          {text && (
            <AnimatedTypography
              variant="body1"
              $inview={inView}
              component="div"
              dangerouslySetInnerHTML={{
                __html: replaceRichTextLinks(text),
              }}
            ></AnimatedTypography>
          )}
        </StyledTextBox>
        <StyledItemListWrapper>
          {itemsList.map((item: any, index: number) => {
            // Extract the URL fragment (part after #) from the item URL
            const urlFragment = item?.url?.split("#")[1]

            // Find the matching station in stationsList by encorID
            const matchingStation = stationsList?.find((station: any) => {
              const encorID = extractProperty(station, "encorID")
              return encorID === urlFragment
            })

            // Use the tab name from matching station, fallback to item name
            const displayName = matchingStation
              ? extractProperty(matchingStation, "tab")
              : item?.name

            return (
              <TransitionUp
                key={index}
                $inView={inView}
                $delay={transitionDelayTime * 0.5 * index}
                style={{ width: "100%" }}
              >
                <StyledLinkDiv
                  href={getNonUmbracoUrl(item?.url)}
                  key={index}
                  onClick={() => {
                    ravKavLocateStations(displayName)
                  }}
                >
                  {displayName}
                </StyledLinkDiv>
              </TransitionUp>
            )
          })}
        </StyledItemListWrapper>
        </Container>
      </StyledDiv>
    </OuterContainer>
  )
}

export default MultyURLS
